type StyleDefinition = {
  seoTag: string;
  label: string;
  tag: string;
  displayName: string;
  cssClass: string;
};

export const defaultStylesMap: Record<string, StyleDefinition> = {
  h1: {
    seoTag: 'h1',
    label: 'FONT_0_LABEL',
    tag: 'h1',
    displayName: 'text_editor_theme_new_1',
    cssClass: 'font_0',
  },
  h2: {
    seoTag: 'h2',
    label: 'FONT_2_LABEL',
    tag: 'h2',
    displayName: 'text_editor_theme_new_2',
    cssClass: 'font_2',
  },
  h3: {
    seoTag: 'h3',
    label: 'FONT_3_LABEL',
    tag: 'h3',
    displayName: 'text_editor_theme_new_3',
    cssClass: 'font_3',
  },
  h4: {
    seoTag: 'h4',
    label: 'FONT_4_LABEL',
    tag: 'h4',
    displayName: 'text_editor_theme_new_4',
    cssClass: 'font_4',
  },
  h5: {
    seoTag: 'h5',
    label: 'FONT_5_LABEL',
    tag: 'h5',
    displayName: 'text_editor_theme_new_5',
    cssClass: 'font_5',
  },
  h6: {
    seoTag: 'h6',
    label: 'FONT_6_LABEL',
    tag: 'h6',
    displayName: 'text_editor_theme_new_6',
    cssClass: 'font_6',
  },
  p: {
    seoTag: 'p',
    label: 'FONT_7_LABEL',
    tag: 'p',
    displayName: 'text_editor_theme_7',
    cssClass: 'font_7',
  },
  div: {
    seoTag: 'p',
    label: 'FONT_8_LABEL',
    tag: 'div',
    displayName: 'text_editor_theme_8',
    cssClass: 'font_8',
  },
  address: {
    seoTag: 'p',
    label: 'FONT_9_LABEL',
    tag: 'address',
    displayName: 'text_editor_theme_9',
    cssClass: 'font_9',
  },
  blockquote: {
    seoTag: 'blockquote',
    label: 'FONT_7_LABEL',
    tag: 'blockquote',
    displayName: 'text_editor_theme_7',
    cssClass: 'font_7',
  },
};
